import { render, staticRenderFns } from "./CourierPickupsManagementTable.vue?vue&type=template&id=0980c4ab&scoped=true&"
import script from "./CourierPickupsManagementTable.vue?vue&type=script&lang=ts&"
export * from "./CourierPickupsManagementTable.vue?vue&type=script&lang=ts&"
import style0 from "./CourierPickupsManagementTable.vue?vue&type=style&index=0&id=0980c4ab&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0980c4ab",
  null
  
)

export default component.exports